import React, { useEffect, useState } from 'react';
import { useRouter } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';
import { Loading } from '../components/Loading';
import { useAuthContext } from './hooks';

type Props = {
  children: React.ReactNode;
};

export function ProtectedRoute({ children }: Props) {
  const router = useRouter();
  const {isAuthenticated, isLoading, user} = useAuthContext()
  const [allow, setAllow] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      if (!isAuthenticated) {
        const searchParams = new URLSearchParams({
          returnTo: window.location.pathname,
        }).toString();
  
        const loginPath = paths.auth.firebase.login;
  
        const href = `${loginPath}?${searchParams}`;
  
        router.replace(href);
      } else if (!user?.firebaseUser?.emailVerified) {
        // need to verify email
        const searchParams = new URLSearchParams({
          returnTo: window.location.pathname,
        }).toString();
  
        const verifyPath = paths.auth.firebase.verify;
  
        const href = `${verifyPath}?${searchParams}`;
  
        router.replace(href);
      } else if (!user?.signedUp) {
        // need to sign up
        const searchParams = new URLSearchParams({
          returnTo: window.location.pathname,
        }).toString();

        const signUpPath = paths.signUp;

        const href = `${signUpPath}?${searchParams}`;

        router.replace(href);
      }

      setAllow(true);
    }
  }, [isAuthenticated, isLoading]);

  if (isLoading) {
    return <Loading />;
  }

  if (!allow) {
    return null;
  }
  
  return children;
}
